import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    closeLabel: { type: String, default: "Close" },
  };

  toggle() {
    const panel = document.getElementById("video_panel");
    if (!panel) return;

    if (panel.dataset.fullscreen === "true") {
      this.close(panel);
    } else {
      this.open(panel);
    }
  }

  open(panel) {
    panel.dataset.fullscreen = "true";
    panel.classList.add(
      "fixed", "inset-0", "z-50",
      "bg-surface", "flex", "flex-col",
      "items-center", "justify-center", "p-4"
    );
    panel.classList.remove("hidden", "lg:block");

    // Add close button
    const closeBtn = document.createElement("button");
    closeBtn.id = "video_fullscreen_close";
    closeBtn.className = [
      "mt-4 px-4 py-2 rounded-ui text-sm font-medium",
      "bg-surface-subtle text-content border border-surface-border",
      "hover:bg-surface-muted",
      "focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-brand-500"
    ].join(" ");
    closeBtn.textContent = this.closeLabelValue;
    closeBtn.addEventListener("click", () => this.close(panel));
    panel.appendChild(closeBtn);
  }

  close(panel) {
    if (!panel) panel = document.getElementById("video_panel");
    if (!panel) return;

    delete panel.dataset.fullscreen;
    panel.classList.remove(
      "fixed", "inset-0", "z-50",
      "bg-surface", "flex", "flex-col",
      "items-center", "justify-center", "p-4"
    );

    // Remove close button
    const closeBtn = document.getElementById("video_fullscreen_close");
    if (closeBtn) closeBtn.remove();
  }
}
